export default "__VITE_ASSET__CRxL2chD__"